@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.ResultsCount {
  @extend %font-family-primary;

  color: $theme-color-primary;
  font-size: $font-size-normal;

  .staticText {
    color: $theme-color-text;
  }
}
